import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { UserServiceService } from '../services/api/user-service.service';
import { SseService } from '../services/api/sse.service';
import { AuthSessionService } from '../services/others/auth-session.service';

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authSession = inject(AuthSessionService);
  const usuarioService = inject(UserServiceService);
  const sseService = inject(SseService);

  if (!authSession.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  return usuarioService.obtenerUsuarioLogeado().pipe(
    map((user) => {
      const isAdmin = user.rolNombre?.toLowerCase() === 'admin';

      if (!isAdmin) {
        router.navigate(['/home-page']);
        return false;
      }

      return true;
    }),
    catchError((err) => {
      console.error('Error al obtener el usuario logeado:', err);
      sseService.disconnect();
      sessionStorage.clear();
      router.navigate(['/login']);
      return of(false);
    }),
  );
};
